import type { FC } from 'react';
import type { BoxProps } from '@mui/material';
import { Stack, useMediaQuery, useTheme } from '@mui/material';

import FIHeaderDesktop from 'src/components/followUpInspirations/components/FIHeader/desktop';
import FIHeaderMobile from 'src/components/followUpInspirations/components/FIHeader/mobile';

import { styles } from './index.styles';

export const FI_HEADER_TEST_ID = 'fi-header';

interface FIHeaderProps extends BoxProps {}

const FIHeader: FC<FIHeaderProps> = () => {
  const theme = useTheme();
  const upLg = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });

  return (
    <Stack
      className="FIHeader-root"
      sx={styles.header}
      data-test-id={FI_HEADER_TEST_ID}
    >
      {upLg ? (
        <FIHeaderDesktop title="Follow-up Inspirations" />
      ) : (
        <FIHeaderMobile />
      )}
    </Stack>
  );
};

export default FIHeader;
